import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const icoMenu = {
    PrecisionManufacturingIcon,
    AddBoxIcon,
    ListAltIcon,
    MenuBookIcon
};

const produccion = {
    id: 'produccion',
    title: '',
    type: 'group',
    children: [
        {
            id: 'produccionMainMenu',
            title: 'Producción',
            type: 'collapse',
            icon: icoMenu.PrecisionManufacturingIcon,
            children: [
                {
                    id: 'crear_orden_produccion',
                    title: 'Crear orden de producción',
                    type: 'item',
                    icon: icoMenu.AddBoxIcon,
                    url: '/user/crear-orden-produccion'
                },
                {
                    id: 'lista_ordenes_produccion',
                    title: 'Lista órdenes de producción',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/lista-ordenes-produccion'
                },
                {
                    id: 'recetas_produccion',
                    title: 'Recetas de producción',
                    type: 'item',
                    icon: icoMenu.MenuBookIcon,
                    url: '/user/recetas-produccion'
                }
            ]
        }
    ]
};

export default produccion;
